export function formatOrderNumberFromId(orderId: string): string {
  return orderId.toUpperCase().slice(0, 4);
}
